var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 9.00033C0.666504 13.6027 4.39746 17.3337 8.99984 17.3337C13.6022 17.3337 17.3332 13.6027 17.3332 9.00033C17.3332 4.39795 13.6022 0.666992 8.99984 0.666992C4.39746 0.666992 0.666504 4.39795 0.666504 9.00033ZM2.33317 9.00033C2.33317 5.31843 5.31794 2.33366 8.99984 2.33366C12.6817 2.33366 15.6665 5.31843 15.6665 9.00033C15.6665 12.6822 12.6817 15.667 8.99984 15.667C5.31794 15.667 2.33317 12.6822 2.33317 9.00033ZM8.99974 3.79199C8.4313 3.79199 7.97698 4.26484 7.9997 4.83283L8.18726 9.52178C8.2047 9.95787 8.5633 10.3024 8.99974 10.3024C9.43617 10.3024 9.79477 9.95787 9.81221 9.52178L9.99977 4.83283C10.0225 4.26485 9.56817 3.79199 8.99974 3.79199ZM7.80192 12.7764C7.80192 12.1292 8.32659 11.6045 8.9738 11.6045C9.62101 11.6045 10.1457 12.1292 10.1457 12.7764C10.1457 13.4236 9.62101 13.9482 8.9738 13.9482C8.32659 13.9482 7.80192 13.4236 7.80192 12.7764Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.96e41f944bc2c2c75529340d84bf6183.svg";
export { ForwardRef as ReactComponent };